import { default as ProductAccessDetails } from "./ProductAccessDetails";
export default ProductAccessDetails;
